import React, { Fragment } from "react"
import { infoBoxStyle } from "../styles/commonStyles"
import { COLORS, TYPOGRAPHY } from "../constants/theme"

const InfoDisplay = ({ label, note = "", value, variant = "default" }) => {
	const labelStyle = {
		fontWeight: TYPOGRAPHY.fontWeight.medium,
		display: "block",
		marginBottom: 4,
		color: COLORS.gray600,
		fontSize: TYPOGRAPHY.fontSize.sm,
	}

	const renderValue = () => {
		if (value === null || value === undefined) {
			return <span style={{ color: COLORS.gray400, fontStyle: "italic" }}>-</span>
		}

		if (typeof value === "string") {
			return value.split("\n").map((line, i) => (
				<Fragment key={i}>
					{i > 0 && <br />}
					{line}
				</Fragment>
			))
		}

		return value
	}

	if (variant === "inline") {
		return (
			<div
				style={{
					display: "flex",
					alignItems: "center",
					gap: 8,
					marginBottom: 8,
				}}
			>
				<label
					style={{
						...labelStyle,
						marginBottom: 0,
						minWidth: "fit-content",
					}}
				>
					{label}:
				</label>
				<div
					style={{
						color: COLORS.gray700,
						fontSize: TYPOGRAPHY.fontSize.sm,
					}}
				>
					{renderValue()}
				</div>
			</div>
		)
	}

	if (variant === "compact") {
		return (
			<div style={{ marginBottom: 8 }}>
				<label style={labelStyle}>{label}</label>
				<div
					style={{
						color: COLORS.gray700,
						fontSize: TYPOGRAPHY.fontSize.sm,
						lineHeight: TYPOGRAPHY.lineHeight.normal,
					}}
				>
					{renderValue()}
				</div>
			</div>
		)
	}

	// Default variant with info box
	return (
		<div style={{ marginBottom: 10 }}>
			<label style={labelStyle}>
				{label} <small>{note}</small>
			</label>

			<div style={infoBoxStyle}>{renderValue()}</div>
		</div>
	)
}

export default InfoDisplay
